export default __webpack_public_path__ + "static/media/reward1_detail_5-2.01cd3939.png";